"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var _1 = require(".");
var debounce = require("lodash.debounce");
require("./style.css");
var DISABLE_CLASS = 'syl-toolbar-disable';
var ToolbarLoader = /** @class */ (function (_super) {
    __extends(ToolbarLoader, _super);
    // @ts-ignore
    function ToolbarLoader(adapter, originOption) {
        var _this = this;
        // 主动设置
        _this._isDisable = false;
        _this.traceEditable = debounce(function () {
            if (!_this._isDisable) {
                if (_this.adapter.editable) {
                    _this.$dom.classList.remove(DISABLE_CLASS);
                }
                else {
                    _this.$dom.classList.add(DISABLE_CLASS);
                }
            }
        }, 300);
        _this.disable = function () {
            _this.isDisable = true;
        };
        _this.enable = function () {
            _this.isDisable = false;
        };
        var option = Object.assign({}, originOption);
        _this = _super.call(this, adapter, option) || this;
        if (!option.mount) {
            var div = document.createElement('div');
            adapter.root.insertBefore(div, adapter.root.childNodes[0]);
            option.mount = div;
        }
        _this.$dom = option.mount;
        if (option.className)
            _this.$dom.classList.add(option.className);
        _this.bridge = new option.RenderBridge(adapter, option.Component, option.mount, 'toolbar');
        adapter.addCommand('toolbar', {
            enable: _this.enable,
            disable: _this.disable,
            getAvailable: function () { return !_this.$dom.classList.contains(DISABLE_CLASS); }
        });
        adapter.on(core_utilities_1.EventChannel.LocalEvent.ON_CHANGE, _this.traceEditable);
        _this.render();
        return _this;
    }
    Object.defineProperty(ToolbarLoader.prototype, "isDisable", {
        get: function () {
            return this._isDisable;
        },
        set: function (val) {
            if (val === this._isDisable)
                return;
            this._isDisable = val;
            // 编辑器不可编辑，也不启用
            if (!this.adapter.editable && !this._isDisable)
                return;
            if (this._isDisable) {
                this.$dom.classList.add(DISABLE_CLASS);
            }
            else {
                this.$dom.classList.remove(DISABLE_CLASS);
            }
        },
        enumerable: true,
        configurable: true
    });
    ToolbarLoader.prototype.setProps = function (_a) {
        var option = _a.option;
        this.option = __assign(__assign({}, this.option), option);
        this.render();
    };
    ToolbarLoader.prototype.render = function () {
        this.bridge.setProps({
            editor: this.adapter,
            option: this.option,
            toolbarLib: new _1.ToolbarLib({ editor: this.adapter, option: this.option })
        });
    };
    ToolbarLoader.prototype.destructor = function () {
        if (this.option.mount) {
            this.option.mount = null;
        }
        this.bridge.unmount();
    };
    return ToolbarLoader;
}(core_utilities_1.BaseModule));
exports.ToolbarLoader = ToolbarLoader;
//# sourceMappingURL=toolbar-loader.js.map